export default () => ({
  allChannels: [],
  statusChannels: undefined,
  limit: 0,
  timezone: undefined,
  availableDates: [],
});
